module.exports = __webpack_public_path__ + "img/pt-BR.fc190c6b.svg";